import {
  HttpRequest,
  HttpEvent,
  HttpInterceptorFn,
  HttpHandlerFn,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import { ToastService } from '../../components/toast/toast.service';

export const hideToastUrls = ['/v1/provider/authentication/login'];

export const apiErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const toastService = inject(ToastService);
  let isHideToast = hideToastUrls.some(url => req.url.includes(url));

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status == 401 && window.location.pathname != '/login') {
        localStorage.removeItem('currentUser');
        window.location.href = '/login';
      } else if (
        error.error.Message &&
        (error.error.ShowMessage === null ||
          error.error.ShowMessage === undefined ||
          error.error.ShowMessage === true)
      ) {
        const errorMessage = error.error.Message;
        if (!isHideToast) {
          toastService.showError(errorMessage);
        }
      } else if (
        !isHideToast &&
        (error.error.ShowMessage === null ||
          error.error.ShowMessage === undefined ||
          error.error.ShowMessage === true)
      ) {
        toastService.showError('An unexpected error occurred.');
      }

      return throwError(() => error);
    }),
  );
};
